import React, { useState } from "react";
import { formBtn1, pageHeader, pageClass } from "../Components/Utils/CustomClasses";
import DefaultProfileLogo from "../assets/Images/DefaultProfileLogo.png";
import EditProfileModal from "../Components/Modals/EditProfileModal";
import UpdatePassword from "../Components/Modals/UpdatePassword";
import { useSelector } from "react-redux";
import { IconEdit, IconLockPassword, IconMail, IconPhone, IconUser } from "@tabler/icons-react";

export default function Profile() {
  const UserDetails = useSelector((state) => state?.login?.userDetails);  
  const [editModal, setEditModal] = useState(false);
  const [updatePassword, setUpdatePassword] = useState(false);
  const handleEditModale = () => {
    setEditModal(true);
  };

  const handlePassword = () => {
    setUpdatePassword(true);
  };

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="p-6  bg-[#FFFFFF] sm:m-5 rounded-xl ">
          <div className="flex justify-between items-center mb-4">
            <div>
              <p className="font-[600] text-[#171717] text-3xl">User Details</p>
            </div>
            <div className="flex gap-10 items-center">
              <div
                className={`flex items-center justify-center gap-2 rounded-full ${formBtn1}`}
              >
                <IconEdit stroke={1.5} size={24} color="white" />
                <button
                  onClick={() => {
                    handleEditModale();
                  }}
                 className="text-sm md:text-base font-medium cursor-pointer">
                  Edit
                </button>
              </div>
              <div
                className={`flex items-center justify-center gap-2 rounded-full ${formBtn1} cursor-pointer`}
              >
                <IconLockPassword stroke={1.5} size={23} color="white" />
                <button
                  onClick={() => {
                    handlePassword();
                  }}
                 className="text-sm md:text-base font-medium">
                  Change Password
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center space-y-5 lg:space-y-0">
            <div className="lg:flex md:flex sm:flex block items-center gap-4 lg:gap-6 w-full justify-center">
              <div className="flex justify-center">
                <img
                  src={DefaultProfileLogo}
                  className="w-16 sm:w-20 md:w-24 lg:w-28 rounded-full justify-center"
                  alt="User"
                />
              </div>
              <div className="w-full">
                <h1 className="text-lg sm:text-xl md:text-2xl font-bold lg:text-left sm:text-left md:text-left text-left leading-6 text-[#171717] capitalize">
                  {UserDetails?.first_name || "----"} {UserDetails?.last_name ||"-----"}
                </h1>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 xxl:grid-cols-3 gap-4 text-gray-500 ">
                  <div className="space-y-2">
                    <div>
                      <p className="font-sans font-[400] text-[#171717]">
                        First name:
                      </p>
                    </div>
                    <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                      <div>
                        <IconUser stroke={1.5} size={23}  className="font-bold text-gray-700" />
                      </div>
                      <p className="">
                        {UserDetails?.first_name || "---"}
                      </p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <p className="font-sans font-[400] text-[#171717]">
                        Last name:
                      </p>
                    </div>
                    <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                      <div>
                        <IconUser stroke={1.5} size={23}  className="font-bold text-gray-700" />
                      </div>
                      <p className="">
                        {UserDetails?.last_name || "---"}
                      </p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <p className="font-sans font-[400] text-[#171717]">
                        Email:
                      </p>
                    </div>
                    <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                      <div>
                        <IconMail stroke={1.5} size={23}  className="font-bold text-gray-700" />
                      </div>
                      <p className="">
                        {UserDetails?.email || "---"}
                      </p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <p className="font-sans font-[400] text-[#171717]">
                        Role:
                      </p>
                    </div>
                    <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                      <div>
                        <IconUser stroke={1.5} size={23}  className="font-bold text-gray-700" />
                      </div>
                      <p className="">
                        {UserDetails?.role?.roleName || "---"}
                      </p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div>
                      <p className="font-sans font-[400] text-[#171717]">
                        Phone:
                      </p>
                    </div>
                    <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                      <div>
                        <IconPhone stroke={1.5} size={23} className="font-bold text-gray-700" />
                      </div>
                      <p className="">
                        {UserDetails?.phone_number || "---"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#FFFFFF] p-4 sm:mt-0  sm:m-5 rounded-xl ">
          <h1 className={` font-[600] text-[#171717] text-3xl pb-4`}>Company Details</h1>
          <div className="flex w-full gap-4">
            <img
              className=" w-28 h-28 border-2 border-sky-400  rounded-full mb-2  "
              src={DefaultProfileLogo}
              alt="Profile Image"
            ></img>
            <div className="flex items-center">
              <p className="font-bold text-[#171717] text-sm sm:text-2xl mb-2 capitalize">
                {UserDetails?.company?.companyName || "-----"}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2  xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2">
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Email:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <div>
                  <IconMail stroke={1.5} size={23}  className="font-bold text-gray-700" />
                </div>
                <p className="capitalize text-slate-600 break-words">{UserDetails?.company?.companyEmail ||"----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Phone:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <div>
                 <IconPhone stroke={1.5} size={23} className="font-bold text-gray-700" />
                </div>
                <p className="capitalize text-slate-600 break-words">{UserDetails?.company?.companyPhone ||"----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Address Line 1:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.addressLine1 || "----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Address Line 2:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.addressLine2 ? UserDetails?.company?.addressLine2 : "----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  City:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.city || "----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  State:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.state || "----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Country:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.country || "----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Color:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.color || "----"}</p>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="font-sans font-[400] text-[#171717]">
                  Pincode:
                </p>
              </div>
              <div className="min-w-0 flex items-center gap-2 box-border p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
                <p className="capitalize  text-slate-600">{UserDetails?.company?.pincode || "----"}</p>
              </div>
            </div>
          </div>
        </div>
        <EditProfileModal editModal={editModal} setEditModal={setEditModal} />
        <UpdatePassword
          updatePassword={updatePassword}
          setUpdatePassword={setUpdatePassword}
          type="change"
        />
      </div>
    </>
  );
}
